import DynamicForm from "components/DynamicForm";
import { Fragment,useEffect } from "react";
import { useDispatch,useSelector } from "react-redux";
import { setRadioFields ,setToggleFields } from "redux/formDisplay";
import {
  changeDigilockerVerified
} from "redux/userInfo";
import "./index.scss";

const Group = (props) => {
  const {
    setSelectedData,
    selectedData,
    handleNext,
    handleAdd,
    handleSkip,
    handleCancel,
    formFields,
    handleBack,
    formErr,
    setFormErr,
    clearFieldError,
    className,
    primaryUser,
    digilocker,
    name,
    custom_styles

  } = props;
  let toggleId;
  let dependentField = [];
  let radioId;
  let radioDependentField = [];
const dispatch = useDispatch()
let digilockerVerified,digilockerVerify = false;
const verification_response = useSelector((state) => state.uploadDocumentReducer?.uploadVerificationResponses);
const response = verification_response[name]
const activeGroup = useSelector((state) => state.userInfo.activeGroup);
const activeSection = useSelector((state) => state.userInfo.activeSection);
const maxActiveGroup = useSelector((state) => state.userInfo.maxActiveGroup);
const maxActiveSection = useSelector(
  (state) => state.userInfo.maxActiveSection
);

if(response?.status == "success" )
{
    dispatch(changeDigilockerVerified(true))
    digilockerVerify = true;
}

if(maxActiveGroup > activeGroup || maxActiveSection> activeSection){
  if(selectedData?.digilocker_callback_response?.status == "success"){
    dispatch(changeDigilockerVerified(true))
    digilockerVerify = true;
  }
}
  useEffect(() => {
    let data = formFields[0]
    if(data.type === "radio") {
      radioId = data.name
    }
    formFields.map((item) => {
      if(item.type === "toggle") {
        toggleId = item.name
      }
      if(String(item?.show).includes(String(toggleId))){
        dependentField.push(item.name)
      } 
      if(String(item?.show).includes(String(radioId))){
        radioDependentField.push(item.name)
      } 
    })  
    if(toggleId) {
      dispatch(setToggleFields({key: toggleId, value: dependentField}))
    }
    if(radioId && radioDependentField.length > 0) {
      dispatch(setRadioFields({key: radioId, value: radioDependentField}))
    }
  },[formFields])
  
  return (
    <div className={`mt-3 bg-theme-grey-2 rounded-3 ${className} ${custom_styles}`}>
     {
      formFields ? (
        <div className={`row position-relative p-3 gy-2 pb-4 ${className ? 'gy-lg-4':'gy-lg-1'}`}>
        {
          digilocker && (digilockerVerified || digilockerVerify) ? (
            <div className="d-flex justify-content-end position-absolute pe-4" style={{top:'30px'}}>
          <div style={{fontSize:'13px'}}>
           <i>DigiLocker Verified</i>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#043D7F" class="bi bi-check-circle-fill ms-1" viewBox="0 0 16 16">
            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
          </svg>
        </div>
        </div>
          ):("")
        }
        {formFields &&
          formFields?.map((item, i) => {
            return (
              <Fragment key={i}>
                <DynamicForm
                  formErr={formErr}
                  setFormErr={setFormErr}
                  clearFieldError={clearFieldError}
                  formFields={item}
                  handleNext={handleNext}
                  handleCancel={handleCancel}
                  handleAdd={handleAdd}
                  handleSkip={handleSkip}
                  handleBack={handleBack}
                  selectedData={selectedData}
                  setSelectedData={setSelectedData}
                  primaryUser={primaryUser}
                />
              </Fragment>
            );
          })}
      </div>
      ):(
        <>
        </>
      )
     }

    </div>
  );
};
export default Group;
